// Components
import GDImageViewer from "../components/shared/GDImageViewer";
import Hero from "../components/layout/Hero";
import SingleNewsImage from "../components/news/SingleNewsImage";

// Assets
import heroImg from "../assets/images/news/hero.jpg";
import "../assets/styles/news.css"

// Hooks
import { useTranslation } from "../hooks/useTranslation";

export default function News() {
    const DIR_ID = process.env.REACT_APP_GD_NEWS_DIR_ID;
    const GDRIVE_KEY = process.env.REACT_APP_GD_API_KEY;
    const t = useTranslation();

    return (
        <section id="newsSection">
            <Hero
                bgImage={heroImg}
                title={t("news.title")}
            />

            <div className="newListWrapper">
                <div className="newsList">
                    <GDImageViewer
                        data={{
                            dirId: DIR_ID,
                            gkey: GDRIVE_KEY,
                            options: {
                                hover: true,
                                onClick: { modal: true },
                                exclude: { "README.png": true },
                                loadingText: t("news.loading"),
                                showDate: true,
                                thumbSize: 500,
                            },
                        }}
                        className="newsCard"
                        classes={{ /* overrides, if any */ }}
                        styles={{ /* overrides, if any */ }}
                        ImageComponent={SingleNewsImage}
                    />
                </div>
            </div>
        </section>
    );
}
